import { isBundledExperienceItem } from 'lib/checkout/checkoutUtils'

export function isMultiCartHotelItem(item: App.MultiCartItem): item is App.MultiCartInstantBookingLEHotelItem {
  return item.type === 'hotel'
}

export function isMultiCartBedbankHotelItem(item: App.MultiCartItem): item is App.MultiCartBedbankHotelItem {
  return item.type === 'bedbankHotel'
}

export function isMultiCartFlightItem(item: App.MultiCartItem): item is App.MultiCartFlightItem {
  return item.type === 'flight'
}

export function isIncompleteReturnFlightMultiCartItem(item: App.MultiCartItem): item is App.MultiCartFlightItem {
  if (!isMultiCartFlightItem(item)) return false

  const flightItem = item.item as App.Checkout.FlightItem
  return flightItem.fareType === 'return' && !flightItem.flights?.[1]?.departingDate
}

export function isDisplayableMultiCartItem(item: App.MultiCartItem): boolean {
  return !isIncompleteReturnFlightMultiCartItem(item) && !isBundledExperienceItem(item.item)
}
